import DemoTravelRuleTableItemDetails from './DemoTravelRuleTableItemDetails'

export default DemoTravelRuleTableItemDetails
